import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgCornerUpLeft(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.293 3.293a1 1 0 1 1 1.414 1.414L6.414 8H13.5c1.954 0 3.464.564 4.598 1.48 1.119.905 1.8 2.095 2.216 3.24.417 1.146.585 2.29.652 3.165a14.585 14.585 0 0 1 .038 1.46l-.003.111-.001.034V20a1 1 0 0 1-2 0v-2.5c0-.304.113-2.233-.564-4.096-.334-.916-.84-1.758-1.596-2.369-.742-.6-1.795-1.035-3.34-1.035H6.414l3.293 3.293.068.076a1 1 0 0 1-1.406 1.406l-.076-.068-5-5a1.005 1.005 0 0 1-.161-.213l-.012-.02-.02-.041a.99.99 0 0 1-.057-.142l-.013-.05a1 1 0 0 1 .007-.51l.006-.024a.992.992 0 0 1 .122-.257c.037-.056.08-.11.128-.157l5-5Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgCornerUpLeft)
